import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function ServicesSection() {
  return (
    <section className="py-14 px-6 bg-navy-900">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-5">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-2 relative p-8 rounded-lg bg-gradient-to-br from-purple-600 via-magenta-600 to-pink-500 overflow-hidden group cursor-pointer"
          >
            <div className="absolute bottom-0 right-0 w-36 h-36 opacity-20">
              <i className="ri-advertisement-line text-[120px] text-white"></i>
            </div>
            <div className="relative z-10">
              <span className="text-xs font-medium text-white/80 uppercase tracking-wider">
                For Advertisers
              </span>
              <h3 className="text-2xl md:text-3xl font-bold text-white mt-2 mb-4">
                Billboard Advertising
              </h3>
              <p className="text-white/90 text-sm mb-6 leading-relaxed">
                From short-term campaigns to long-term brand presence, we deliver results with full creative support and strategic planning.
              </p>
              <Link
                to="/en/advertise"
                className="inline-flex items-center gap-2 px-6 py-2.5 bg-white text-magenta-600 rounded-full font-semibold text-sm hover:shadow-xl transition-all whitespace-nowrap cursor-pointer"
              >
                View Plans
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="lg:col-span-3 relative p-8 rounded-lg bg-gradient-to-br from-yellow-500 via-neon-gold to-amber-400 overflow-hidden group cursor-pointer"
          >
            <div className="absolute bottom-0 right-0 w-48 h-48 opacity-20">
              <i className="ri-money-dollar-circle-line text-[150px] text-black"></i>
            </div>
            <div className="relative z-10">
              <span className="text-xs font-medium text-black/70 uppercase tracking-wider">
                For Investors
              </span>
              <h3 className="text-2xl md:text-3xl font-bold text-black mt-2 mb-4">
                Billboard Ownership & Investment
              </h3>
              <p className="text-black/80 text-sm mb-6 max-w-md leading-relaxed">
                Generate stable cash flow through advertising revenue while maximizing tax benefits with accelerated depreciation.
              </p>
              <Link
                to="/en/partnership"
                className="inline-flex items-center gap-2 px-6 py-2.5 bg-black text-neon-gold rounded-full font-semibold text-sm hover:shadow-xl transition-all whitespace-nowrap cursor-pointer"
              >
                Learn More
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
